module.exports = __webpack_public_path__ + "static/img/qw_1.6de9dcfa.png";